import { createMuiTheme } from '@material-ui/core/styles';
import 'typeface-open-sans/index.css';
import 'typeface-roboto-slab/index.css';

export default createMuiTheme({
  palette: {
    primary: {
      main: '#50805E',
    },
    secondary: {
      main: '#FFD371',
    },
    warning: {
      main: '#AE8D6C',
    },
    info: {
      main: '#586AAD',
    },
    error: {
      main: '#ff0000',
    },
    textSecondary: {
      main: '#333333',
    },
  },
  spacing: 10,
  typography: {
    fontFamily: [
      'Open Sans',
      'Roboto Slab',
      '-apple-system',
      'BlinkMacSystemFont',
      '"Segoe UI"',
      'Roboto',
      '"Helvetica Neue"',
      'Arial',
      'sans-serif',
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(','),
    h1: {
      fontFamily: 'Roboto Slab',
      marginBottom: 10,
      marginTop: 15,
      fontSize: '3rem',
    },
    h2: {
      fontFamily: 'Roboto Slab',
      marginBottom: 10,
      marginTop: 15,
      fontSize: '2.8rem',
    },
    h3: {
      fontFamily: 'Roboto Slab',
      marginBottom: 10,
      marginTop: 15,
      fontSize: '2.5rem',
    },
    h4: {
      fontFamily: 'Roboto Slab',
      marginBottom: 10,
      marginTop: 15,
      fontSize: '1.8rem',
    },
    h5: {
      fontFamily: 'Roboto Slab',
      marginBottom: 10,
      marginTop: 15,
      fontSize: '1.5rem',
    },
    h6: {
      fontFamily: 'Roboto Slab',
      marginBottom: 20,
      fontSize: '1.2rem',
      fontWeight: 400,
    },
    body1: {
      marginBottom: 20,
    },
    body2: {
      marginBottom: 0,
    },
    bodyterms: {
      height: '80vh',
      overflow: 'scroll',
    },
  },
  link: {
    color: '#50805E',
  },
  overrides: {
    // Style sheet name ⚛️
    MuiButton: {
      // Name of the rule
      root: {
        // Some CSS
        borderRadius: 3,
      },
      label: {
        color: '#FFD371',
        textTransform: 'capitalize',
      },
    },
    MuiChip: {
      root: {
        marginRight: 5,
      },
      label: {
        color: '#FFD371',
      },
    },
    MuiToggleButton: {
      root: {
        '&$selected': {
          backgroundColor: '#50805E',
          color: '#FFD371',
        },
      },
    },
    MuiFormControlLabel: {
      root: {
        fontSize: '0.8em',
      },
    },
  },
});
